__turbopack_context__.v({
  "className": "pt_serif_5f09e214-module__DQHybW__className",
});
